import { formatPhoneNumber } from '../../../lib/numUtils.js';
import formTypeMap from 'lib/formTypeMap.js';

const getInboxMessageSnippet = (message) => {
  const platform = message.message.platform || {};
  const detailType = ['facebookmessenger', 'apexchat', 'sitestaffchat'].includes(platform.code) ? platform.code : message.type;
  const phone = message.phone || message.message.phone || message.message.tracking_number;
  const formType = formTypeMap[message.message.form_type] || 'Web Form';
  const webFormName = detailType === 'web_forms' && message.message.web_form_name ? `${formType} - ${message.message.web_form_name}` : undefined;

  return (
    webFormName ||
    message.snippet ||
    {
      phone_calls: phone ? formatPhoneNumber(phone) : undefined,
      texts: 'Text Message',
      facebookmessenger: 'Facebook Messenger',
      web_forms: 'Web Form',
      apexchat: 'Chat',
      sitestaffchat: 'Chat',
    }[detailType] ||
    '\u00A0'
  );
};

export default getInboxMessageSnippet;
